var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$utils.isPhone())?_c('sub-h5-resume-add'):_c('sub-pc-resume-add')
}
var staticRenderFns = []

export { render, staticRenderFns }